// extracted by mini-css-extract-plugin
export default {"step_create":"style_step_create__Amzmt","step_block":"style_step_block__0o6VL"};